import { KEY_MAX_LENGTH } from '@gonfalon/strings/patterns';

export const MAX_ENVIRONMENT_KEY_LENGTH = KEY_MAX_LENGTH;
export const MAX_ENVIRONMENT_NAME_LENGTH = 256;
export const DEFAULT_PRODUCTION_ENVIRONMENT_KEY = 'production';

export const truncateKey = (key: string) => key.substring(0, MAX_ENVIRONMENT_KEY_LENGTH);
